import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0aa51a44"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["tabindex"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_color_picker = _resolveComponent("oxd-color-picker")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.classes),
    tabindex: _ctx.tabIndex,
    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args))),
    onFocus: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args))),
    onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args))),
    onKeydown: [
      _cache[5] || (_cache[5] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args)), ["prevent"]), ["esc"])),
      _cache[6] || (_cache[6] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.onEnter && _ctx.onEnter(...args)), ["prevent"]), ["enter"]))
    ]
  }, [
    _createElementVNode("div", {
      class: "oxd-color-input-preview",
      style: _normalizeStyle(_ctx.previewStyles)
    }, null, 4),
    _createVNode(_Transition, { name: "transition-fade-down" }, {
      default: _withCtx(() => [
        (_ctx.open)
          ? (_openBlock(), _createBlock(_component_oxd_color_picker, {
              key: 0,
              modelValue: _ctx.modelValue,
              class: _normalizeClass(_ctx.dropdownClasses),
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
            }, null, 8, ["modelValue", "class"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 42, _hoisted_1)), [
    [_directive_click_outside, _ctx.onClose]
  ])
}